import React, { Component } from 'react';
import { Table, Switch, InputNumber, Icon } from 'antd';
import PropTypes from 'prop-types';
import styles from './TableContent.module.scss';
import { XPagination, showConfirm } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip } from '@/components/TableCell';


export default class TableContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    _columns = () => ([
        {
            title: '异常类型',
            dataIndex: 'exceptionType',
            key: 'exceptionType',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        // {
        //     title: '等待时长(min)',
        //     dataIndex: 'exceptionType',
        //     key: 'exceptionType',
        //     width: '20%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '责任方',
            dataIndex: 'responsiblePartyValue',
            key: 'responsiblePartyValue',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '使用次数',
            dataIndex: 'useNum',
            key: 'useNum',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '排序',
            dataIndex: 'sortNo',
            key: 'sortNo',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
            // render: (text, item) => this.sortCell(text, item)
        },
        // {
        //     title: '使用场景',
        //     dataIndex: 'processingLogicValue',
        //     key: 'processingLogicValue',
        //     width: '20%',
        //     align: 'center',
        //     onCell: tooltipStyle,
        //     render: tooltip
        // },
        {
            title: '处理逻辑',
            dataIndex: 'processingLogicValue',
            key: 'processingLogicValue',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            align: 'center',
            render: (text, item) => this._switchCell(text, item)
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this._tableAction(id, record)
        }
    ]);

    _tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (< div className={styles.action} >
            <div className={styles.item} onClick={() => tableAction(id, 'editor', record)}>编辑</div>
            {/* <div className={styles.item} onClick={() => tableAction(id, 'delete')}>删除</div> */}
        </div >);
    };

    // 表格项内容为可编辑
    sortCell = (value, item) => {
        const label = React.createRef();
        const box = React.createRef();
        const input = React.createRef();

        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <div className={styles.sort_box}>
                    <div className={styles.label} ref={label}>{value}</div>
                    <div className={styles.input} ref={box}>
                        <InputNumber
                            key={item.id}
                            style={{ width: '70px' }}
                            ref={input}
                            defaultValue={value}
                            min={1}
                            max={99}
                            precision={0}
                            placeholder='请输入'
                            onBlur={(e) => {
                                box.current.style.display = 'none';
                                label.current.style.display = 'block';
                                if (e.target.value && (value != e.target.value)) {
                                    this.props.tableAction(item, 'sort', e.target.value);
                                }
                            }}
                        />
                    </div>
                    <div
                        className={styles.icon}
                        onClick={() => {
                            label.current.style.display = 'none';
                            box.current.style.display = 'block';
                            input.current.focus();
                        }}
                    >
                        <Icon type="edit" style={{ fontSize: '18px' }} />
                    </div>
                </div>
            </div>
        );
    };

    // 开关
    _switchCell = (sw, item) => {
        let checked = true;
        if (sw == '0') {
            checked = false;
        }
        return (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
                <Switch
                    checkedChildren="开"
                    unCheckedChildren="关"
                    checked={checked}
                    onChange={(value) => {
                        if (sw == '1') {
                            showConfirm('禁用提醒', ' 您正在禁用异常类型，禁用后骑士APP将不可再选择到该异常类型，确定要禁用么？', () => {
                                this.props.tableAction(item, 'switch', value);
                            });
                        } else {
                            this.props.tableAction(item, 'switch', value);
                        }

                    }}
                />
            </div>
        );
    };

    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        if (data) {
            return data.map(item => {
                return item;
            });
        }
    }

    //渲染组件
    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableContent.propTypes = {
    renderData: PropTypes.object, // 表格数据源
    paginationChange: PropTypes.func, // 分页
    tableAction: PropTypes.func, // 对表格的操作
};